import React, { useEffect, useState } from "react";
import ModalImumRules from "./ModalImumRules";
import ContentBlock from "../Layout/ContentBlock";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import { useDispatch, useSelector } from "react-redux";
import {
  ButtonSecondary,
  InputSwitchComponent,
  Pagination,
  SelectCountry,
  Switch,
  TextInput,
} from "../globals";
import TableUi from "../Layout/TableUI";
import {
  duplicateImumRule,
  getImumRules,
  removeImumRule,
} from "../../redux/Actions/imum_rules_action";
import { ButtonDelete, ButtonSmall } from "../common/Buttons";
import { IconDuplicate, IconEdit } from "../Layout/Icons";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../helpers/FunctionsGlobal";
import { flag_icons, getDateFormat } from "../../helpers/Utils";
import RangePickerComp from "../common/RangePickerComp";
import AntdConfirm from "../../helpers/AntdConfirm";
import { Tooltip } from "antd";
import { addOverFlow, removeOverFlow } from "../../helpers/modalFunc";
import Spinner from "../common/Spinner";
import { DEFAULT_IMUM_RULES_PER_PAGE } from "../../helpers/default";
import { globalPostMethod } from "../../redux/Actions/global_action";

const filterInitial = {
  title_cont_any: "",
  user_firstname_or_user_lastname_cont_any: "",
  countries_raw_cont: undefined,
  active_true: "",
  valid_from_gteq: "",
  valid_to_lt: "",
};

const ImumRules = ({ page, setPage }) => {
  const dispatch = useDispatch();
  const { loading, data, totals, current } = useSelector(
    (state) => state.custom
  );
  const [filters, setFilters] = useState(filterInitial);
  const [filterString, setfilterString] = useState("");
  const [modalAction, setModalAction] = useState(null);
  console.log("ImumRules: ", loading, data, totals, current);
  useEffect(() => {
    console.log("fetching information");
    dispatch(getImumRules(page, filterString));
  }, [page, filterString]);

  useEffect(() => {
    if (typeof modalAction === "number") {
      addOverFlow();
    } else {
      removeOverFlow();
    }
  }, [modalAction]);

  const onEdit = (imum_rule_id) => {
    setModalAction(imum_rule_id);
  };

  const onFilter = () => {
    let filterStr = "";
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key])) {
        filters[key].forEach((arr) => {
          filterStr += `&q[${key}][]=${arr}`;
        });
      } else if (filters[key]) {
        filterStr += `&q[${key}]=${filters[key]}`;
      }
    });
    setfilterString(filterStr);
  };

  if (current !== "imum_rules") {
    return <Spinner />;
  }

  return (
    <div className="row">
      <ContentBlock containerClass="pt-3">
        <TableFilterBox
          // extraClass="mx-3"
          add={false}
          filter={true}
          onFilter={() => onFilter()}
          clearFilter={() => setFilters(filterInitial)}
          button1={
            <div className="ml-1 float-left">
              <button
                type="button"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => setModalAction(0)}
              >
                {"Create new"}
              </button>
            </div>
          }
        >
          <div className="px-1">
            <TextInput
              text="Rule title"
              name="title_cont_any"
              style={{ width: 165 }}
              value={filters.title_cont_any}
              onKeyDown={handleKeyDown2(onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <TextInput
              text="User"
              name="user_firstname_or_user_lastname_cont_any"
              style={{ width: 165 }}
              value={filters.user_firstname_or_user_lastname_cont_any}
              onKeyDown={handleKeyDown2(onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div
            className="px-1"
            // style={{
            //   width: 212,
            // }}
          >
            <SelectCountry
              value={filters.countries_raw_cont}
              style={{ width: 165 }}
              onChange={(value) => {
                onChangeUseState(setFilters)({
                  target: {
                    name: "countries_raw_cont",
                    value,
                  },
                });
              }}
            />
          </div>
          <div
            className="px-1"
            // style={{
            //   width: 200,
            // }}
          >
            <InputSwitchComponent
              label="Status"
              name="active_true"
              options={[
                {
                  label: "All",
                  value: "",
                },
                {
                  label: "Active",
                  value: "1",
                },
                {
                  label: "Inactive",
                  value: "0",
                },
              ]}
              value={filters.active_true}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <RangePickerComp
              label="Date"
              style={{ width: 250 }}
              placeholder={["Start time", "End time"]}
              disabledDate={() => {}}
              value={[
                getDateFormat(filters.valid_from_gteq),
                getDateFormat(filters.valid_to_lt),
              ]}
              onChange={(_, args) => {
                setFilters((prev) => ({
                  ...prev,
                  valid_from_gteq: args[0],
                  valid_to_lt: args[1],
                }));
              }}
              onCalendarChange={(_, value) => {
                setFilters((prev) => ({
                  ...prev,
                  valid_from_gteq: value[0],
                  valid_to_lt: value[1],
                }));
              }}
              // renderExtraFooter={() => (
              //   <div className="d-flex align-items-center justify-content-center">
              //     {!!filters.valid_from_gteq && (
              //       <div
              //         className="text-primary py-2 cursor-pointer"
              //         onClick={() => {
              //           setFilters((prev) => ({
              //             ...prev,
              //             valid_to_lt: "",
              //           }));
              //         }}
              //       >
              //         Do not set end date
              //       </div>
              //     )}
              //   </div>
              // )}
            />
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation loader={loading} array={data || []}>
            <TableUi
              hoverable={false}
              ths={[
                "Rule title",
                "User",
                "Last edit by",
                "Assigned by",
                "Countries.",
                "Schedule",
                "Period",
                "Status",
                "",
              ]}
            >
              {data?.map((item_rule) => {
                return (
                  <ItemRuleColumn
                    key={item_rule.id}
                    item_rule={item_rule}
                    onEdit={onEdit}
                  />
                );
              })}
            </TableUi>
            <Pagination
              className="pb-3"
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={DEFAULT_IMUM_RULES_PER_PAGE}
            />
          </ContentValidation>
        </div>
      </ContentBlock>
      {typeof modalAction == "number" && (
        <ModalImumRules id={modalAction} modalFunc={setModalAction} />
      )}
    </div>
  );
};

export default ImumRules;

const ItemRuleColumn = ({ item_rule, onEdit }) => {
  const dispatch = useDispatch();
  return (
    <TableUi.tr>
      <TableUi.td className={"p-left"}>{item_rule.title}</TableUi.td>
      <TableUi.td>{item_rule.user}</TableUi.td>
      <TableUi.td>{item_rule.editor}</TableUi.td>
      <TableUi.td>
        <div
          style={{
            width: 400,
          }}
        >
          {!!item_rule.current_categories?.length && (
            <>
              <div className="text-xss font-medium">Categories</div>
              <div className="d-flex flex-wrap my-1">
                {item_rule.current_categories.map((d, idx) => (
                  <div
                    key={`${d}_${idx}`}
                    className="d-flex align-items-center justify-content-center text-xs mb-1 mr-1"
                    style={{
                      backgroundColor: "#F5F5F5",
                      borderRadius: 2,
                      padding: "4px 5px 4px 6px",
                    }}
                  >
                    {d}
                  </div>
                ))}
              </div>
            </>
          )}
          {!!item_rule.current_brands?.length && (
            <>
              <div className="text-xss font-medium">Brands</div>
              <div className="d-flex flex-wrap my-1">
                {item_rule.current_brands.map((d, idx) => (
                  <div
                    key={`${d}_${idx}`}
                    className="d-flex align-items-center justify-content-center text-xs mb-1 mr-1"
                    style={{
                      backgroundColor: "#F5F5F5",
                      borderRadius: 2,
                      padding: "4px 5px 4px 6px",
                    }}
                  >
                    {d}
                  </div>
                ))}
              </div>
            </>
          )}
          {!!item_rule.current_tags?.length && (
            <>
              <div className="text-xss font-medium">Include tags</div>
              <div className="d-flex flex-wrap my-1">
                {item_rule.current_tags.map((d, idx) => (
                  <div
                    key={`${d}_${idx}`}
                    className="d-flex align-items-center justify-content-center text-xs mb-1 mr-1"
                    style={{
                      backgroundColor: "#F5F5F5",
                      borderRadius: 2,
                      padding: "4px 5px 4px 6px",
                    }}
                  >
                    {d}
                  </div>
                ))}
              </div>
            </>
          )}{" "}
          {!!item_rule.current_exclude_tags?.length && (
            <>
              <div className="text-xss font-medium">Exclude tags</div>
              <div className="d-flex flex-wrap my-1">
                {item_rule.current_exclude_tags.map((d, idx) => (
                  <div
                    key={`${d}_${idx}`}
                    className="d-flex align-items-center justify-content-center text-xs mb-1 mr-1"
                    style={{
                      backgroundColor: "#F5F5F5",
                      borderRadius: 2,
                      padding: "4px 5px 4px 6px",
                    }}
                  >
                    {d}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </TableUi.td>
      <TableUi.td>
        {item_rule.countries?.map((value) => (
          <span key={value} className="pr-1">
            {flag_icons[value]}
          </span>
        ))}
      </TableUi.td>
      <TableUi.td>
        {item_rule.schedule_days && item_rule.schedule_days.join(", ")} at{" "}
        {item_rule.schedule_time}
      </TableUi.td>
      <TableUi.td>
        {item_rule.valid_from} - {item_rule.valid_to}
      </TableUi.td>
      <TableUi.td>
        <Switch checked={item_rule.active} disabled={true} />
      </TableUi.td>
      <TableUi.td>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 0fr)",
            gap: 5,
          }}
        >
          <Tooltip placement="top" title="Duplicate">
            <div>
              <ButtonSmall
                type="outline"
                onClick={() => {
                  AntdConfirm({
                    onOk() {
                      dispatch(duplicateImumRule(item_rule.id));
                      console.log("OK");
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                }}
              >
                <IconDuplicate color="#03B0F7" />
              </ButtonSmall>
            </div>
          </Tooltip>
          <Tooltip placement="top" title="Edit">
            <div>
              <ButtonSmall onClick={() => onEdit(item_rule.id)}>
                <IconEdit color={"#fff"} />
              </ButtonSmall>
            </div>
          </Tooltip>
          <Tooltip placement="top" title="Delete">
            <div>
              <ButtonDelete
                onDelete={() => {
                  AntdConfirm({
                    onOk: () => {
                      dispatch(removeImumRule(item_rule.id));
                    },
                  });
                }}
              />
            </div>
          </Tooltip>
        </div>
        <div className="mt-2">
          <ButtonSecondary
            onClick={() =>
              globalPostMethod(`/api/v1/imum_rules/${item_rule.id}/execute`)
            }
          >
            Test call
          </ButtonSecondary>
        </div>
      </TableUi.td>
    </TableUi.tr>
  );
};
